import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

const Spinner = ({
  loading,
  mensaje = "Procesando información...",
}) => {
  if (!loading) return null;

  return (
    <Dimmer
      active
      page
      style={{
        background: "rgba(15, 23, 42, 0.35)",
        backdropFilter: "blur(3px)",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          background: "#ffffff",
          padding: "34px 38px",
          borderRadius: 20,
          minWidth: 320,
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
          animation: "fadeIn 0.25s ease",
        }}
      >
        {/* Contenedor loader */}
        <div
          style={{
            width: 72,
            height: 72,
            margin: "0 auto 20px",
            borderRadius: "50%",
            background: "#eef6ff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader active inline size="medium" />
        </div>

        {/* Título */}
        <div
          style={{
            fontSize: 20,
            fontWeight: 700,
            color: "#111827",
            marginBottom: 8,
          }}
        >
          {mensaje}
        </div>

        {/* Subtexto */}
        <div
          style={{
            fontSize: 14,
            color: "#6b7280",
            fontWeight: 400,
          }}
        >
          Espere un momento...
        </div>
      </div>
    </Dimmer>
  );
};

export default Spinner;